<template>
    <st-filters-pagination
        stateModule="administrator/decisionList"
        :filters="filters"
        :total="total"
        @change="doFilter"
        :moreFilters="false"
        :header="$t('DECISION.LIST.TITLE')"
        :showErase="false"
    >
        <template #filters-toolbar>
            <slot name="toolbar">
            </slot>
        </template>

        <slot></slot>
    </st-filters-pagination>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { FilterSchema } from '@/shared/form/filter-schema';
    import { DecisionModel } from '@/modules/administrator/models/decision-model';

    const { fields } = DecisionModel;

    const filterSchema = new FilterSchema([
        fields.name,
    ]);

    export default {
        name: 'DecisionListFilter',
        props: {
            selectedInstitution: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                filters: filterSchema.fields
            }
        },
        computed: {
            ...mapGetters({
               total: 'administrator/decisionList/total',
            }),
        },
        methods: {
            ...mapActions({
                doFetch: 'administrator/decisionList/getDecisions',
            }),
            refresh() {
                this.doFilter(this.params);
            },
            doFilter(params) {
                this.params = params;
                this.doFetch({payload: params, id: this.selectedInstitution.id});
            },
        },
    };
</script>
